import { createSelector } from 'reselect';
import CartItems from '@components/cart/models/CartItems';

const cartItems = state => state.cart.items;

export const selectCartItems = createSelector(
	[cartItems],
	(rawCartItems) => {
		const cartItems = new CartItems([...rawCartItems]);
		return cartItems.splitItemGroups();
	},
);
